// extracted by mini-css-extract-plugin
module.exports = {"pl_18px":"InputPayment_pl_18px__4Ueq8","mt_16px":"InputPayment_mt_16px__vdzlJ","label":"InputPayment_label__kwAjt"};